import { createCardLayoutStyles } from '~/pages/anatomy/quizBinaryChoice/libs/styles/cardLayout'
import { COLORS } from '~/shared/constants/uiConstants'

export const Styles = createCardLayoutStyles({
  secondBehind: COLORS.PURPLE_100,
  firstBehind: '#fdfcf7',
  front: '#ffd387',
})
